export enum RelationshipFieldType {
  UNI = 'UNI',
  ProjectDerivatives = 'Project Derivatives',
  Contextualizations = 'Contextualizations',
  Companion = 'Companions',
  DPU = 'DPU',
  Modification = 'Modification',
  Association = 'Association',
  Series = 'Series',
  Translation = 'Translations'
}
